import React, {useEffect, useState} from 'react';
import { Submit } from './FormControls';
import tw from 'twin.macro'
import Button from '../Button';

import ProcessFieldSets from './ProcessFieldSets';
import ProcessFormField from './ProcessFormField';

const ProcessFormPage = ({ 
    page, 
    dispatch, 
    formState, 
    isActive, 
    setActivePage, 
    lastPage, 
    firstPage, 
    submitButton 
}) => {


    return (
        <section css={[tw`hidden`, isActive && tw`block`]}>
            <div>
                <ProcessFieldSets formFields={page.fields} dispatch={dispatch} formState={formState} />
            </div>
            <div>
                {!lastPage ? <Button onClick={() => setActivePage(page.id + 1)}>Continue</Button> : null}
                {lastPage ? <Submit label={submitButton?.text || "Submit"} loading={formState.submitting} /> : null}
                {!firstPage ? <Button link onClick={() => setActivePage(page.id - 1)}>Back</Button> : null}
            </div>

            {(formState?.message?.text) && (
                <div 
                    tw="max-w-md px-5 py-3 bg-red-200 border-red-600 border my-5 rounded text-red-800" 
                    aria-live="polite"
                    role="alert"
                >
                    <p>It looks like there is some information missing. Please double check and try again.</p>
                </div>
            )}
        </section>
    )
}


export default ProcessFormPage